export default "__VITE_ASSET__CNht2adv__"